import { render, staticRenderFns } from "./SenseiAnagraphic.vue?vue&type=template&id=82545d72&scoped=true&"
import script from "./SenseiAnagraphic.vue?vue&type=script&lang=js&"
export * from "./SenseiAnagraphic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82545d72",
  null
  
)

export default component.exports